import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SelectionModel } from 'src_common/common/websocket2/models/SelectionModel/SelectionModel';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { MarketModel } from 'src_common/common/websocket2/models/MarketModel';
import { numberOfItemsInRaceBox } from 'src/domains/sportsbook/webview/components/nextRaces/racesSlider/NextRacesSliderList';
import { sortSelectionsByCriteria } from 'src_common/utils/sport/sort';
import { CardBodyListItem } from 'src/domains/sportsbook/webview/components/racesSlider/horseRacing/cardBody/CardBody.style';
import { CardBodyItem } from 'src/domains/sportsbook/webview/components/racesSlider/horseRacing/cardBodyItem/CardBodyItem';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export interface CardBodyPropsType {
    race: EventModel;
    market: MarketModel;
    sortSelections: (list: Array<SelectionModel>) => Array<SelectionModel>;
}

export const CardBody = observer('CardBody', (props: CardBodyPropsType): JSX.Element | null => {
    const { race, market, sortSelections } = props;
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    const prepareDisplayOrder = (event: EventModel): string => {
        const tagsDisplayOrder = event.tagsDisplayOrder;

        if (tagsDisplayOrder !== undefined && tagsDisplayOrder !== '-') {
            return tagsDisplayOrder;
        }
        return 'by-price';
    };

    const filteredSelections = sortSelections(market.selections)
        .filter((x) => x.resultType !== 'void' && x.display)
        .slice(0, numberOfItemsInRaceBox);

    const itemsForView = sortSelectionsByCriteria(filteredSelections, prepareDisplayOrder(race));

    return (
        <ul key='race-box-selections'>
            {itemsForView.map((selection, index) => {
                return (
                    <CardBodyListItem
                        key={`${selection.id2.toOldId()}-${index}`}
                        variant={configState.componentVariants.raceCardVariant}
                    >
                        <CardBodyItem selectionId={selection.id2} />
                    </CardBodyListItem>
                );
            })}
        </ul>
    );
});
